<template>
  <div>
    <!-- 编辑、添加界面 -->
    <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="900px" :destroy-on-close="true" :before-close="cancel">
     <el-form label-width="90px" ref="form" :model="form" :rules="rules" label-suffix=":">
      <div style="display: flex;flex-wrap: wrap;width: 100%;">
         <el-form-item label="付款单位" prop="invoiceTitle"
            :rules="{ required: true, message: '请选择付款单位', trigger: 'change' }">
            <el-input style="width: 100%;" v-model="form.invoiceTitle" auto-complete="off" placeholder="请选择付款单位"
              :disabled="selectType.type === 'claim'"></el-input>
          </el-form-item>
          <el-form-item label="收款单位" prop="receivingUnitId"
            :rules="{ required: true, message: '请选择收款单位', trigger: 'change' }">
            <el-select v-model="form.receivingUnitId" style="width: 100%;" filterable placeholder="请输入收款单位"
              :disabled="selectType.type === 'claim'">
              <el-option v-for="(item, index) in businessOption" :key="index" :label="item.companyName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="到款金额" prop="paymentAmount">
            <el-input v-model="form.paymentAmount" auto-complete="off" style="width: 100%;"
              :disabled="selectType.type === 'claim'" placeholder="请输入到款金额"></el-input>
          </el-form-item>
          <el-form-item label="到款日期" prop="paymentDate">
            <el-input style="width: 100%;" v-model="form.paymentDate" auto-complete="off"
              :disabled="selectType.type === 'claim'" placeholder="请输入日期，格式yyyy-MM-dd"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remark" style="width: 96%!important;">
            <el-input   :autosize="{ minRows: 3 }" type="textarea" maxlength="300"
              :disabled="selectType.type === 'claim'" show-word-limit placeholder="请输入内容" v-model="form.remark">
            </el-input>
          </el-form-item>


          <el-form-item label="认领类型" v-if="selectType.type === 'claim'" prop="claimType"
            :rules="{ required: true, message: '请选择认领类型', trigger: 'change' }">
            <el-radio-group v-model="form.claimType">
              <el-radio label="INVOICE">项目款</el-radio>
              <el-radio label="CONTRACT">垫付款</el-radio>
            </el-radio-group>
          </el-form-item>
         <el-form-item :label="form.claimType === 'INVOICE' ? '项目款' : '垫付款'" v-if="selectType.type === 'claim'" style="margin-bottom: 0;">
            <div style="font-size: 14px;color: red;" v-if="form.claimType === 'INVOICE'">
              <span>项目的真实到款</span>
            </div>
            <div style="font-size: 14px;color: red;margin-top: -20px;"
              v-if="form.claimType === 'CONTRACT'">
              <span>为了拿到数据客户/销售垫付的项目款，后面会退回</span>
              <span>合同金额需与垫付款金额一致</span>
            </div>
          </el-form-item>

          <el-form-item label="发票" v-if="selectType.type === 'claim' && form.claimType === 'INVOICE'" prop="invoiceId"
            :rules="{ required: true, message: '请选择发票', trigger: 'change' }">
            <el-select v-model="form.invoiceId" style="width: 100%;" filterable placeholder="请选择发票">
              <el-option v-for="item in invoiceOptions" :key="item.id"
                :label="(item.invoiceNumber ? item.invoiceNumber : '') + '-' + item.invoiceTitle"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合同" prop="contractId" v-if="selectType.type === 'claim' && form.claimType === 'CONTRACT'"
            :rules="{ required: true, message: '请选择合同', trigger: 'change' }">
            <el-select v-model="form.contractId" style="width: 100%;" filterable placeholder="请选择合同" :remote="true"
              :remote-method="remoteMethod" :loading="loading" @change="onContractChange">
              <el-option v-for="(item, index) in contractOption" :key="index"
                :label="item.contractNumber + '-' + item.contractName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合同金额" v-if="selectType.type === 'claim' && form.claimType === 'CONTRACT'"
            prop="contractAmount">
            <el-input style="width: 100%;" v-model="form.contractAmount" disabled></el-input>
          </el-form-item>

          <el-form-item label="认领附件" prop="file" v-if="selectType.type === 'claim'">
            <div style="display: flex;align-items: center">
              <el-input style="width: 300px;" v-model="fileName" readonly></el-input>
              <el-upload style="margin-left: 10px" class="upload-demo" action="" :auto-upload="false"
                :show-file-list="false" :on-change="handleChange" :file-list="fileList" :on-exceed="handleExceed">
                <el-button size="small" icon="el-icon-plus" type="primary"></el-button>
              </el-upload>
              <el-button size="small" style="margin-left: 10px" type="danger" icon="el-icon-delete"
                @click="handleRemove"></el-button>
            </div>
          </el-form-item>
         <el-form-item label="认领备注" prop="claimRemark" v-if="selectType.type === 'claim'"
            style="width: 96%!important;">
            <el-input style="width: 100%;" :autosize="{ minRows: 3 }" type="textarea" maxlength="300" show-word-limit
              placeholder="请输入内容" v-model="form.claimRemark">
            </el-input>
          </el-form-item>

      </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel">取消</el-button>
        <el-button size="small" type="primary" class="title" @click="handle">提交</el-button>
      </div>
    </el-dialog>
    <loading :loading="dataLoading" load-text="数据加载中"></loading>
  </div>
</template>

<script>

import {getInvoice} from "@/api/dilivery/tickets";
import {checkDate} from "@/utils/rules";
import {padDate} from "@/store/date";
import {getCompanyPage} from "@/api/dilivery/company";
import { addPendingPayment, editPendingPayment, claimPendingPayment } from "@/api/dilivery/pending-payment";
import { getAllContract } from "@/api/dilivery/sales/contract";
import Loading from "@/components/loading/Loading.vue";

export default {
  name: "AddEditPayment",
  components: {
    Loading
  },
  props:{
    showDialog:{
      default:false
    },
    selectType: {
      default: () => ({})
    },
    selectDetail: {
      default:() => ({})
    }
  },
  data(){
    return{
      title:'',
      loading:false,
      dataLoading: false,
      invoiceOptions: [],
      businessOption:[],
      fileName:'',
      fileList:[],
      form:{
        id: '',
        pendingPaymentId: '',
        claimType: 'INVOICE',
        contractId: '',
        invoiceId: '',
        contractAmount: '',
        claimRemark: '',
        file: null,
        remark: '',
        paymentAmount: '',
        paymentDate: '',
        invoiceTitle:'',
        receivingUnitId:''
      },
      rules: {
        contractAmount: [
          {
            validator: (rule, value, callback) => {
              if (Number(value) !== Number(this.form.paymentAmount)) {
                return callback(new Error('合同金额需与到款金额一致'));
              }
              return callback(); // 验证通过
            }, trigger: 'change'
          }
        ],
        paymentAmount: [
          {required: true,message: '请输入到款金额', trigger: 'change'},
          { validator: (rule, value, callback) => {
              if (isNaN(value)) {
                return callback(new Error('请输入数字值'));
              }
              if (value <= 0) {
                return callback(new Error('金额必须大于0'));
              }
              return callback(); // 验证通过
            }, trigger: 'change' }
        ],
        paymentDate: [
          {required: true, message: '请选择到款时间', trigger: 'change'},
          {validator: checkDate, trigger: 'change'}
        ]
      },
    }
  },
  watch:{
    selectType:{
      handler(newVal){
        if (newVal && Object.keys(newVal)){
          if(newVal.type==='edit'){
            this.title='编辑到款信息'
          }else if(newVal.type === 'claim') {
            this.title='到款信息认领'
          }else{
            this.title='添加到款信息'
          }
        }
      },
      immediate:true
    },
    selectDetail:{
      handler(newVal){
        if(newVal&&Object.keys(newVal)){
          this.form.id = newVal.id
          this.form.pendingPaymentId = newVal.id
          this.form.invoiceTitle = newVal.invoiceTitle
          this.form.receivingUnitId = newVal.receivingUnitId
          this.form.paymentAmount = newVal.paymentAmount
          this.form.paymentDate = newVal.paymentDate
          this.form.remark = newVal.remark
        }
      },
      immediate:true
    },
  },
  mounted() {
    this.dataLoading = true
    Promise.all([
      this.remoteMethod(),
      this.getInvoiceOption(),
      this.getBusinessOption()
    ]).finally(() => {
      this.dataLoading = false
    })
  },
  methods:{
    handleExceed(files) {
      this.$messageUi.error('只能上传一个文件，请先移除已有文件再上传');
    },
    handleChange(file,fileList){
      this.form.file = file
      this.fileList = [file]
      this.fileName = file.name
    },
    handleRemove(file,fileList) {
      this.form.file = null
      this.fileList = []
      this.fileName = ''
    },
    getInvoiceOption(){
      try {
        getInvoice().then(res => {
          if(res.code === 200){
            this.invoiceOptions = res.data.filter(item => Number(item.billingUnitId) === Number(this.selectDetail.receivingUnitId))
          }
        })
      } catch (error) {
        console.log(error);
      }
    },
    remoteMethod(query) {
      try {
        this.contractOption = [];
        this.loading = true;
        const data = {}
        if (this.selectDetail.receivingUnitId) {
          data["query#trusteeCompanyId.IN"] = this.selectDetail.receivingUnitId
        }
        if (query) {
          data["query#contractNumber.LIKE"] = query
        }
        getAllContract('ADVANCE_PAYMENT_CONTRACT', data).then(res => {
          if (res.code === 200) {
            this.loading = false;
            this.contractOption = res.data
          }
        })
      } catch (error) {
        console.log(error);
        this.contractOption = [];
        this.loading = false;
      }
    },
    onContractChange(value) {
      const found = this.contractOption.find(item => item.id === value)
      if (found) {
        this.form.contractAmount = found.contractAmount || found.amount || ''
      } else {
        this.form.contractAmount = ''
      }
    },
    getBusinessOption() {
      try {
        let params = {
          'page.current': 1,
          'page.size': 500,
          'order': 'id.asc'
        }
        getCompanyPage(params, {}).then(res => {
          if (res.code === 200) {
            this.businessOption = res.data.records
          }
        })
      } catch (error) {
        console.log(error);
      }
    },
    cancel(){
      this.$emit('submit','cancel')
    },
    handle() {
      this.$refs.form.validate(valid=>{
        if(valid){
          this.form.paymentDate = padDate(this.form.paymentDate)
          if (this.selectType.type === 'edit') {
            editPendingPayment([this.form]).then(res => {
              if (res.code === 200) {
                this.$emit('submit','confirm')
                this.$messageUi.success('修改成功')
              }
            }).catch(err => {
            })
          } else if(this.selectType.type === 'add') {
            addPendingPayment([this.form]).then(res => {
              if (res.code === 200) {
                this.$emit('submit','confirm')
                this.$messageUi.success('提交成功')
              }
            }).catch(err => {
            })
          }else{
            let data = {
              pendingPaymentId: this.form.pendingPaymentId,
              claimType: this.form.claimType,
              contractId: this.form.claimType === 'CONTRACT' ? this.form.contractId : undefined,
              invoiceId: this.form.claimType === 'INVOICE' ? this.form.invoiceId : undefined,
              remark: this.form.claimRemark
            }
            const formData = new FormData();
            const jsonStr = JSON.stringify(data);
            const blob = new Blob([jsonStr], {
              type: 'application/json'
            });
            formData.append("info", blob);
            if(this.form.file){
              formData.append('file', this.form.file.raw); // 文件
            }
            claimPendingPayment(formData).then(res => {
              if (res.code === 200) {
                this.$emit('submit', 'confirm')
                this.$messageUi.success('申请认领成功')
                this.$store.commit('right/setChangeRed', true)
              }
            }).catch(err => {
            })
          }
        }else {
          this.$nextTick(() => {
            let err = document.getElementsByClassName('is-error')
            if (err.length) {
              err[0].scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              })
            }
          })
          this.$messageUi.error('填写参数不规范，请检查')
        }
      })
    }
  },

}
</script>

<style scoped>
.el-form-item {
  width: 48% !important;
}
</style>
